import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=2b9be22c&"
import script from "./userManagement.vue?vue&type=script&lang=js&"
export * from "./userManagement.vue?vue&type=script&lang=js&"
import style0 from "./userManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports